import React, { Component, PropTypes } from 'react'
import { browserHistory, Link } from 'react-router'
import { FormattedNumber } from '../misc'
import moment from 'moment'
import path from 'path'

import { storage } from '../../utils'

import {
    detectAndShowErrors,
    getProperty,
    getNumericValueOf,
    jobStatus,
    DATE_FORMAT,
} from '../utils'

import { Loading } from '../misc'
import Header from '../header'
import {
    formHandler,
    Button,
    Label,
    MultipleFileUpload,
    TextInput,
} from '../ui'
import OvertimeRequestForm from './overtime_request_form'

const MILEAGE_RATE = 0.62

const descriptionLabelStyle = {
    fontWeight: 'bold',
    textAlign: 'right',
    textTransform: 'uppercase',
}

class InvoiceForm extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    onboarding_complete: PropTypes.bool.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        jobs: PropTypes.shape({
            job: PropTypes.object,
            errors: PropTypes.object,
        }).isRequired,
        jobsActions: PropTypes.shape({
            uploadReceiptError: PropTypes.func.isRequired,
            uploadReceipt: PropTypes.func.isRequired,
            submitInvoice: PropTypes.func.isRequired,
        }).isRequired,
        modalActions: PropTypes.shape({
            showModal: PropTypes.func.isRequired,
        }).isRequired,
    }

    constructor(props) {
        super(props)

        let data = {}

        if (props.jobs.job) {
            data = {
                ...this._extractReceipts(props.jobs.job.receipts),
                ...props.jobs.job,
            }
        }

        this.state = { data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.jobs.job !== this.props.jobs.job) {
            this.setState({
                data: {
                    ...this._extractReceipts(nextProps.jobs.job.receipts),
                    ...nextProps.jobs.job,
                },
            })
        }

        detectAndShowErrors(this.props, nextProps, 'jobs.errors')
    }

    _extractReceipts(receipts) {
        const newReceipts = {
            rented_gear_files: [],
            meals_files: [],
            hard_drive_files: [],
            shipping_files: [],
            gas_files: [],
            parking_files: [],
            taxi_files: [],
            additional_files: [],
        }

        if (receipts) {
            for (const receipt of receipts) {
                let key = 'additional_files'

                if (receipt.receipt_type) {
                    key = `${ receipt.receipt_type.toLowerCase() }_files`
                }

                newReceipts[key].push(receipt)
            }
        }

        return newReceipts
    }

    _calculateTotalOwed() {
        return (
            getNumericValueOf(this.props.jobs, 'job.labour') +
            getNumericValueOf(this.state, 'data.owned_gear') +
            getNumericValueOf(this.state, 'data.rented_gear') +
            getNumericValueOf(this.state, 'data.meals') +
            getNumericValueOf(this.state, 'data.hard_drive') +
            getNumericValueOf(this.state, 'data.shipping') +
            getNumericValueOf(this.state, 'data.gas') +
            getNumericValueOf(this.state, 'data.parking') +
            getNumericValueOf(this.state, 'data.taxi') +
            getNumericValueOf(this.state, 'data.misc') +
            getNumericValueOf(this.props.jobs, 'job.overtime') +

            // turn miles into cash
            (getNumericValueOf(this.state, 'data.total_miles') * MILEAGE_RATE)
        )
    }

    _fileUploadField(type, field, extraProps) {
        const token = storage.getItem('authToken')

        return (
            <MultipleFileUpload
                appendValue={ this._appendFile.bind(this, field) }
                data={{
                    production_crew: this.props.jobs.job.uuid,
                    receipt_type: type,
                }}
                error={ this.props.jobs.errors[field] }
                errorAction={ this.props.jobsActions.uploadReceiptError }
                fileNameSuffix={{ token }}
                helpText={
                    'Please upload any receipts for this item in PDF, PNG or JPG format. The ' +
                    'file size must not exceed 5MB.'
                }
                label="Upload receipt"
                multiple
                name={ `${ field }` }
                removeValue={ this._removeFile.bind(this, field) }
                uploadAction={ this.props.jobsActions.uploadReceipt }
                value={
                    getProperty(this.state, `data.${ field }`, []).map(
                        (item) => {
                            return {
                                id: item.uuid,
                                uuid: item.uuid,
                                file: item.receipt,
                                name: path.basename(item.receipt_name),
                            }
                        }
                    )
                }
                { ...extraProps }
            />
        )
    }

    _appendFile = (field, file) => {
        // take a copy of the current value for this field
        const newValue = [ ...getProperty(this.state, `data.${ field }`, []) ]

        // append the new version
        newValue.push(file)

        // now set it on our state
        this.setState({
            data: {
                ...this.state.data,
                [field]: newValue,
            },
        })
    }

    _removeFile = (field, id) => {
        // eslint-disable-next-line no-alert
        if (confirm('Are you sure you wish to remove this receipt?')) {
            // take a copy of the current value for this field and filter out the item with the id
            const newValue = getProperty(this.state, `data.${ field }`, []).filter((item) => item.uuid !== id)

            // now set it on our state
            this.setState({
                data: {
                    ...this.state.data,
                    [field]: newValue,
                },
            })
        }
    }

    _cancelSubmit() {
        browserHistory.goBack()
    }

    _submitInvoice = () => {
        // first populate data to be sent with the standard form data
        const data = {
            owned_gear: getNumericValueOf(this.state, 'data.owned_gear'),
            owned_gear_desc: getProperty(this.state, 'data.owned_gear_desc', null),
            rented_gear: getNumericValueOf(this.state, 'data.rented_gear'),
            meals: getNumericValueOf(this.state, 'data.meals'),
            hard_drive: getNumericValueOf(this.state, 'data.hard_drive'),
            shipping: getNumericValueOf(this.state, 'data.shipping'),
            gas: getNumericValueOf(this.state, 'data.gas'),
            total_miles: getNumericValueOf(this.state, 'data.total_miles'),
            mileage_desc: getProperty(this.state, 'data.mileage_desc', null),
            parking: getNumericValueOf(this.state, 'data.parking'),
            taxi: getNumericValueOf(this.state, 'data.taxi'),
            misc: getNumericValueOf(this.state, 'data.misc'),
            misc_desc: getProperty(this.state, 'data.misc_desc', null),
            notes: getProperty(this.state, 'data.notes', null),
            overtime: getNumericValueOf(this.state, 'data.overtime'),
        }

        data.mileage = Number(data.total_miles * MILEAGE_RATE).toFixed(2)

        // start to create the receipts array with the additional uploads
        data.receipts = [
            ...getProperty(this.state.data, 'additional_files', []).map((item) => item.uuid),
        ]

        // now add the specific receipts on if there is a value set against each expense
        if (data.rented_gear > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'rented_gear_files', []).map((item) => item.uuid)
            )
        }

        if (data.meals > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'meals_files', []).map((item) => item.uuid)
            )
        }

        if (data.hard_drive > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'hard_drive_files', []).map((item) => item.uuid)
            )
        }

        if (data.shipping > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'shipping_files', []).map((item) => item.uuid)
            )
        }

        if (data.gas > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'gas_files', []).map((item) => item.uuid)
            )
        }

        if (data.parking > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'parking_files', []).map((item) => item.uuid)
            )
        }

        if (data.taxi > 0) {
            data.receipts.push(
                ...getProperty(this.state.data, 'taxi_files', []).map((item) => item.uuid)
            )
        }

        // add the job UUID to the request data
        data.production_crew = this.props.jobs.job.uuid

        this.props.jobsActions.submitInvoice(data)
    }

    _showRequestOvertimeForm = () => {
        this.props.modalActions.showModal({
            component: (
                <OvertimeRequestForm
                    crewUUID={ this.props.account.user.crew.uuid }
                    jobUUID={ this.props.jobs.job.uuid }
                />
            ),
            modalProps: {
                allowClose: true,
                title: 'Request overtime',
            },
        })
    }

    render() {
        const job = this.props.jobs.job

        if (! job) {
            return (
                <div>
                    <Header title="New Invoice" />

                    <div className="content">
                        <div className="content__inner">
                            <Loading />
                        </div>
                    </div>
                </div>
            )
        }

        if (job.job_status !== jobStatus.FINISHED && job.job_status !== jobStatus.REJECTED) {
            return (
                <div>
                    <Header title="New Invoice" />

                    <div className="content">
                        <div className="content__inner">
                            <p>Sorry you can't invoice this job at this time.</p>

                            <Link className="btn btn--primary" to="/jobs">
                                Back to current jobs & billing
                            </Link>
                        </div>
                    </div>
                </div>
            )
        }

        const errors = this.props.jobs.errors

        const labelGridClassName = 'grid grid__span-2'
        const controlGridClassName = 'grid grid__span-3'
        const receiptGridClassName = 'grid grid__span-7'
        const descriptionLabelGridClassName = 'grid grid__span-2'
        const descriptionGridClassName = 'grid grid__span-5'

        const labelStyle = {
            fontWeight: 'bold',
            textTransform: 'uppercase',
        }

        return (
            <div>
                <Header title="New Invoice" />

                <div className="content">
                    { this.props.account.user.crew.onboarding_complete || (
                        <div className="content__inner">
                            <div className="alert alert--error text-strong">
                                Please fully complete your profile to be considered for the maximum
                                number of job opportunities.
                            </div>
                        </div>
                    ) }

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Job Details
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <div className="grid grid--break-mobile">
                                    <div className="grid grid__span-6">
                                        <p>Invoice date: { moment().format(DATE_FORMAT) }</p>
                                    </div>
                                    <div className="grid grid__span-6">
                                        <p>Job number: { job.job_number }</p>
                                        <p>Job date: { job.job_date.format(DATE_FORMAT) }</p>
                                        <p>Job client: { getProperty(job.client_obj, 'name', 'N/A') }</p>
                                        <p>Job crew: { getProperty(job.crew_type_obj, 'name', 'N/A') }</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Job Billing & Expenses
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Labor</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <Label inline>
                                            <FormattedNumber
                                                currency="USD"
                                                style="currency"
                                                value={ getNumericValueOf(job, 'labour') }
                                            />
                                        </Label>
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Owned gear</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.owned_gear }
                                            name="owned_gear"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.owned_gear') }
                                        />
                                    </div>
                                    { do {
                                        if (getNumericValueOf(this.state, 'data.owned_gear') > 0) {
                                            <div>
                                                <div className={ descriptionLabelGridClassName }>
                                                    <Label inline style={ descriptionLabelStyle }>Description</Label>
                                                </div>
                                                <div className={ descriptionGridClassName }>
                                                    <TextInput
                                                        error={ errors.owned_gear_desc }
                                                        name="owned_gear_desc"
                                                        placeholder="REQUIRED"
                                                        required
                                                        updateValue={ this._updateValue }
                                                        value={ getProperty(this.state, 'data.owned_gear_desc') }
                                                    />
                                                </div>
                                            </div>
                                        }
                                    } }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Reimbursable Expenses
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <p className="alert alert--warning text-strong" style={{ color: '#000' }}>
                                    Please note that reimbursements are subject to MWAC's approval
                                    unless pre-approved before your job. If the fields below are
                                    pre-populated then those expenses have been pre-approved.
                                </p>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Rented gear</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.rented_gear }
                                            name="rented_gear"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.rented_gear') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.rented_gear') > 0) {
                                                this._fileUploadField('RENTED_GEAR', 'rented_gear_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Meals</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.meals }
                                            name="meals"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.meals') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.meals') > 0) {
                                                this._fileUploadField('MEALS', 'meals_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Hard drive</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.hard_drive }
                                            name="hard_drive"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.hard_drive') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.hard_drive') > 0) {
                                                this._fileUploadField('HARD_DRIVE', 'hard_drive_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Shipping</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.shipping }
                                            name="shipping"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.shipping') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.shipping') > 0) {
                                                this._fileUploadField('SHIPPING', 'shipping_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Gas</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.gas }
                                            name="gas"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.gas') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.gas') > 0) {
                                                this._fileUploadField('GAS', 'gas_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Mileage</Label>
                                    </div>
                                    <div className="grid grid__span-2">
                                        <TextInput
                                            error={ errors.total_miles }
                                            name="total_miles"
                                            subHelp="Input Total Miles Driven"
                                            suffix="miles"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.total_miles') }
                                        />
                                    </div>
                                    <div className="grid grid__span-2">
                                        <div className="grid__span-2">
                                            <Label inline>=</Label>
                                        </div>
                                        <div className="grid__span-10">
                                            <TextInput
                                                disabled
                                                name="mileage"
                                                prefix="$"
                                                value={
                                                    Number(
                                                        getNumericValueOf(this.state, 'data.total_miles') * MILEAGE_RATE
                                                    ).toFixed(2)
                                                }
                                            />
                                        </div>
                                    </div>
                                    { do {
                                        if (getNumericValueOf(this.state, 'data.total_miles') > 0) {
                                            <div>
                                                <div className={ descriptionLabelGridClassName }>
                                                    <Label inline style={ descriptionLabelStyle }>Description</Label>
                                                </div>
                                                <div className="grid grid__span-3">
                                                    <TextInput
                                                        error={ errors.mileage_desc }
                                                        name="mileage_desc"
                                                        placeholder="REQUIRED"
                                                        required
                                                        updateValue={ this._updateValue }
                                                        value={ getProperty(this.state, 'data.mileage_desc') }
                                                    />
                                                </div>
                                            </div>
                                        }
                                    } }
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Parking</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.parking }
                                            name="parking"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.parking') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.parking') > 0) {
                                                this._fileUploadField('PARKING', 'parking_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Taxi</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.taxi }
                                            name="taxi"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.taxi') }
                                        />
                                    </div>
                                    <div className={ receiptGridClassName }>
                                        { do {
                                            if (getNumericValueOf(this.state, 'data.taxi') > 0) {
                                                this._fileUploadField('TAXI', 'taxi_files')
                                            }
                                        } }
                                    </div>
                                </div>

                                <div className="grid grid--break-mobile">
                                    <div className={ labelGridClassName }>
                                        <Label inline style={ labelStyle }>Misc expenses</Label>
                                    </div>
                                    <div className={ controlGridClassName }>
                                        <TextInput
                                            error={ errors.misc }
                                            name="misc"
                                            prefix="$"
                                            type="number"
                                            updateValue={ this._updateValue }
                                            value={ getProperty(this.state, 'data.misc') }
                                        />
                                    </div>
                                    { do {
                                        if (getNumericValueOf(this.state, 'data.misc') > 0) {
                                            <div>
                                                <div className={ descriptionLabelGridClassName }>
                                                    <Label inline style={ descriptionLabelStyle }>Description</Label>
                                                </div>
                                                <div className={ descriptionGridClassName }>
                                                    <TextInput
                                                        error={ errors.misc_desc }
                                                        name="misc_desc"
                                                        placeholder="REQUIRED"
                                                        required
                                                        updateValue={ this._updateValue }
                                                        value={ getProperty(this.state, 'data.misc_desc') }
                                                    />
                                                </div>
                                            </div>
                                        }
                                    } }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Overtime
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                { do {
                                    if (getNumericValueOf(job, 'overtime') === 0) {
                                        <div>
                                            <p
                                                className="alert alert--warning text-strong"
                                                style={{ color: '#000' }}
                                            >
                                                Please note that by requesting overtime, you will
                                                not be able to submit this invoice and the data you
                                                have entered so far will be lost.
                                            </p>
                                            <Button onClick={ this._showRequestOvertimeForm } status="primary">
                                                Request overtime
                                            </Button>
                                        </div>
                                    } else {
                                        <div>
                                            <Label>Overtime</Label>
                                            <FormattedNumber
                                                currency="USD"
                                                style="currency"
                                                value={ getNumericValueOf(job, 'overtime') }
                                            />
                                        </div>
                                    }
                                } }
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Notes/comments
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <TextInput
                                    error={ errors.notes }
                                    name="notes"
                                    rows="10"
                                    type="textarea"
                                    updateValue={ this._updateValue }
                                    value={ getProperty(this.state, 'data.notes') }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Additional receipts & attachments
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                {
                                    this._fileUploadField('', 'additional_files', {
                                        helpText: (
                                            <p>
                                                Please upload any additional receipts or attachments
                                                for this invoice in PDF, PNG or JPG format. The file
                                                size must not exceed 5MB.
                                            </p>
                                        ),
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="content__inner">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">
                                    Grand Total
                                </div>
                            </div>
                            <div className="box__content box__content--padded">
                                <p className="heading">
                                    { 'Grand total owed: ' }
                                    <FormattedNumber
                                        currency="USD"
                                        style="currency"
                                        value={ this._calculateTotalOwed() }
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="submit-row">
                    <div className="pull-left">
                        <Button
                            large
                            loading={ this.props.appState.loading }
                            onClick={ this._submitInvoice }
                            status="create"
                        >
                            Submit invoice
                        </Button>
                    </div>
                    <div className="pull-right">
                        <Button
                            large
                            loading={ this.props.appState.loading }
                            onClick={ this._cancelSubmit }
                            status="cancel"
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default InvoiceForm



// WEBPACK FOOTER //
// ./app/components/jobs/invoice_form.js